/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { NgModule, ModuleWithProviders } from '@angular/core';

import { JsEventsComponent } from './components/js-events.component';
import { JsEventsServerConfig } from './config/js-events.config';
import { JsEventsDefaultConfig } from './constants/js-events.constants';

@NgModule({
    imports: [JsEventsComponent],
    exports: [JsEventsComponent]
})
export class JsEventsModule {
    static forRoot(config?: JsEventsServerConfig): ModuleWithProviders<JsEventsModule> {
        return {
            ngModule: JsEventsModule,
            providers: [
                {
                    provide: JsEventsServerConfig,
                    useValue: config || JsEventsDefaultConfig
                }
            ]
        };
    }
}
